import React, { FunctionComponent, SVGProps } from "react";

export const LocationPinIcon: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      {...props}
      fill="none"
      height="28"
      viewBox="0 0 22 28"
      width="22"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M11 1.75c-2.45325 0-4.80603.97455-6.54074 2.70926C2.72455 6.19397 1.75 8.54675 1.75 11c0 4.23 2.35889 8.0572 4.81595 10.8829 1.21938 1.4022 2.44068 2.5322 3.35729 3.3113.44316.3766.81376.6702 1.07676.8718.263-.2016.6336-.4952 1.0768-.8718.9166-.7791 2.1379-1.9091 3.3572-3.3113C17.8911 19.0572 20.25 15.23 20.25 11c0-2.45325-.9746-4.80603-2.7093-6.54074C15.806 2.72455 13.4533 1.75 11 1.75ZM11 27c-.4301.6144-.4303.6143-.4306.6141l-.0007-.0005-.0021-.0015-.0069-.0048-.0244-.0174c-.0209-.015-.0511-.0367-.0898-.0649-.0775-.0566-.1893-.1395-.3306-.2475-.28258-.2159-.68342-.5327-1.16314-.9404-.95838-.8147-2.23709-1.9972-3.51771-3.47C2.89111 19.9428.25 15.77.25 11c0-2.85108 1.13259-5.58538 3.1486-7.6014C5.41462 1.38259 8.14892.25 11 .25c2.8511 0 5.5854 1.13259 7.6014 3.1486C20.6174 5.41462 21.75 8.14892 21.75 11c0 4.77-2.6411 8.9428-5.184 11.8671-1.2807 1.4728-2.5594 2.6553-3.5178 3.47-.4797.4077-.8805.7245-1.1631.9404-.1413.108-.2531.1909-.3306.2475-.0387.0282-.0689.0499-.0898.0649l-.0244.0174-.0069.0048-.0021.0015-.0007.0005c-.0003.0002-.0005.0003-.4306-.6141Zm0 0 .4301.6144c-.2582.1808-.602.1808-.8602 0L11 27Zm0-19.25c-1.79493 0-3.25 1.45507-3.25 3.25 0 1.7949 1.45507 3.25 3.25 3.25 1.7949 0 3.25-1.4551 3.25-3.25 0-1.79493-1.4551-3.25-3.25-3.25ZM6.25 11c0-2.62335 2.12665-4.75 4.75-4.75 2.6234 0 4.75 2.12665 4.75 4.75 0 2.6234-2.1266 4.75-4.75 4.75-2.62335 0-4.75-2.1266-4.75-4.75Z"
        fill="#64748B"
        fillRule="evenodd"
      />
    </svg>
  );
};
